export enum QuoteTypeEnum {
    LifeInsurance = 1,
    MortgageProtection = 2,
    IncomeProtection = 3,
    IllnessCover = 4,
    Mortgage = 5,
    ExecutiveIncomeProtection = 6,
    Pensions = 7,
    Investments = 8,
    Savings = 9
}
